import Component from '../../common/Component';
export default class DashboardWidget extends Component {
  view(vnode) {
    return m("div", {
      className: 'DashboardWidget Widget ' + this.className()
    }, this.content(vnode));
  }
  className() {
    return '';
  }
  content(vnode) {
    return null;
  }
}
flarum.reg.add('core', 'admin/components/DashboardWidget', DashboardWidget);